<template>
  <v-container fluid class="px-2 px-sm-4 px-md-6 pt-4 pb-0">
    <v-card class="verbas-cfp" flat>
      <div class="verbas-cfp__topo">
        <div class="verbas-cfp__texto">
          <span class="verbas-cfp__kicker">{{ $t("CFP") }}</span>
          <strong>Verbas usadas no cálculo da folha</strong>
          <small
            >Cada verba diz como calcular (hora, dia, percentual ou valor),
            sobre qual base e onde incide (INSS, IRRF e FGTS, pela classificação
            do eSocial). Verbas com pendência não podem ser usadas no
            fechamento.</small
          >
        </div>
        <div class="verbas-cfp__acoes">
          <v-chip
            v-if="!carregando"
            small
            outlined
            :color="pendentes.length ? 'orange darken-2' : 'green darken-1'"
            :disabled="!pendentes.length"
            @click="mostrarPendentes = !mostrarPendentes"
          >
            <v-icon left small>{{
              pendentes.length
                ? "mdi-alert-outline"
                : "mdi-check-circle-outline"
            }}</v-icon>
            {{
              pendentes.length
                ? `${pendentes.length} verba(s) com pendência`
                : "Todas as verbas classificadas"
            }}
          </v-chip>
          <v-chip
            v-if="!carregando && semVerba.length"
            small
            outlined
            color="orange darken-2"
            @click="mostrarSemVerba = !mostrarSemVerba"
          >
            <v-icon left small>mdi-link-variant-off</v-icon>
            {{ semVerba.length }}
            {{ semVerba.length === 1 ? "papel" : "papéis" }} do cálculo sem
            verba
          </v-chip>
          <v-btn
            v-if="hasPermission('ROLE_FuncionarioFolhaPagamentoVerba_Update')"
            :class="btnSecundario"
            height="39"
            @click="abrirPadrao"
          >
            <v-icon left>mdi-auto-fix</v-icon> Assistente de rubricas padrão
          </v-btn>
        </div>
      </div>
      <v-expand-transition>
        <div v-if="mostrarPendentes && pendentes.length">
          <v-simple-table dense class="verbas-cfp__pendentes">
            <tbody>
              <tr v-for="v in pendentes" :key="v.id">
                <td class="text-no-wrap">
                  <strong>{{ v.codigo }}</strong>
                </td>
                <td>{{ v.descricao }}</td>
                <td class="text-caption orange--text text--darken-2">
                  {{ v.pendencias.join(" ") }}
                </td>
              </tr>
            </tbody>
          </v-simple-table>
          <div class="text-caption text--secondary mt-1">
            Edite a verba na lista abaixo para completar a classificação.
          </div>
        </div>
      </v-expand-transition>
      <v-expand-transition>
        <div v-if="mostrarSemVerba && semVerba.length">
          <v-simple-table dense class="verbas-cfp__pendentes">
            <tbody>
              <tr v-for="p in semVerba" :key="p.papel">
                <td class="text-no-wrap">
                  <strong>{{ p.papelDescricao }}</strong>
                </td>
                <td class="text-caption text--secondary">
                  {{ p.grupo
                  }}{{ p.folhas ? ` · folha ${folhasDoPapel(p)}` : "" }}
                </td>
                <td class="text-caption orange--text text--darken-2">
                  {{
                    p.candidataId
                      ? `Sugestão: ${verbaSugerida(p)}`
                      : "Nenhuma verba com a classificação usual deste papel."
                  }}
                </td>
              </tr>
            </tbody>
          </v-simple-table>
          <div class="text-caption text--secondary mt-1">
            O cálculo que precisar de um destes papéis termina com erro. Edite a
            verba sugerida na lista abaixo e escolha o papel em "Papel no
            cálculo", ou use o assistente de rubricas padrão, que vincula as
            sugeridas e cria as que faltam.
          </div>
        </div>
      </v-expand-transition>
    </v-card>

    <CarregandoFolha :mensagem="ocupado" />

    <!-- Assistente -->
    <v-dialog v-model="padrao.aberto" max-width="1100" scrollable>
      <v-card class="point-calculation-dialog">
        <v-card-title class="point-calculation-dialog__title">
          <v-avatar color="#eef1ff" size="40">
            <v-icon color="#5e72e4" size="21">mdi-auto-fix</v-icon>
          </v-avatar>
          <div>
            <strong>Assistente de rubricas padrão</strong>
            <small
              >Uma verba para cada papel calculado automaticamente (salário,
              INSS, IRRF, férias, 13º, rescisão...).</small
            >
          </div>
          <v-spacer />
          <v-btn icon aria-label="Fechar" @click="padrao.aberto = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <div class="text-body-2 text--secondary mb-3">
            Para cada papel sugerimos vincular uma verba que você já usa ou
            criar uma nova com a classificação do eSocial. Revise e confirme.
          </div>
          <v-data-table
            v-model="padrao.selecionadas"
            :headers="headersPadrao"
            :items="padrao.propostas"
            item-key="papel"
            :loading="padrao.carregando"
            show-select
            dense
            :items-per-page="-1"
            hide-default-footer
            group-by="grupo"
          >
            <template v-slot:[`item.acao`]="{ item }">
              <v-chip
                x-small
                outlined
                :color="
                  { CRIAR: 'primary', VINCULAR: 'blue', MANTER: 'grey' }[
                    item.acao
                  ]
                "
              >
                {{
                  {
                    CRIAR: "Criar",
                    VINCULAR: "Vincular",
                    MANTER: "Já configurada",
                  }[item.acao] || item.acao
                }}
              </v-chip>
            </template>
            <template v-slot:[`item.rubrica`]="{ item }">
              {{ item.codigo }} - {{ item.descricao }}
              <div class="text-caption text--secondary">{{ item.motivo }}</div>
            </template>
            <template v-slot:[`item.classificacao`]="{ item }">
              <span class="text-caption">
                Nat. {{ item.natureza }} · INSS {{ item.codIncCP }} · IRRF
                {{ item.codIncIRRF }} · FGTS {{ item.codIncFGTS }}
              </span>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <span class="text-caption text--secondary"
            >{{ padrao.selecionadas.length }} selecionada(s)</span
          >
          <v-spacer />
          <v-btn
            :class="btnSecundario"
            height="39"
            @click="padrao.aberto = false"
          >
            <v-icon left>mdi-arrow-left</v-icon> Voltar
          </v-btn>
          <v-btn
            :class="btnPrimario"
            height="39"
            :disabled="!padrao.selecionadas.length || !!ocupado"
            @click="aplicarPadrao"
          >
            <v-icon left>mdi-check</v-icon> Aplicar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import "@/components/pessoal/funcionario-ponto/FuncionarioPontoCalculo.css";
import FuncionarioFolhaPagamentoVerbaDataService from "@/services/pessoal/FuncionarioFolhaPagamentoVerbaDataService";
import folhaUi from "@/components/pessoal/folha-calculo/folhaUi";
import CarregandoFolha from "@/components/pessoal/folha-calculo/CarregandoFolha.vue";

// Folhas em que o motor exige a verba do papel (TipoFolhaCalculo).
const FOLHAS = {
  MENSAL: "mensal",
  ADIANTAMENTO: "adiantamento",
  FERIAS: "férias",
  DECIMO_TERCEIRO_PRIMEIRA: "13º 1ª parcela",
  DECIMO_TERCEIRO_SEGUNDA: "13º 2ª parcela",
  RESCISAO: "rescisão",
  COMPLEMENTAR: "complementar",
  PLR: "PLR",
};

// Painel do módulo CFP na listagem de verbas: pendências de classificação, papéis do cálculo sem verba e
// assistente de rubricas padrão.
export default {
  name: "ResumoCalculoVerbas",
  components: { CarregandoFolha },
  mixins: [folhaUi],
  data() {
    return {
      carregando: false,
      verbas: [],
      semVerba: [],
      mostrarPendentes: false,
      mostrarSemVerba: false,
      ocupado: null,
      padrao: {
        aberto: false,
        carregando: false,
        propostas: [],
        selecionadas: [],
      },
      headersPadrao: [
        { text: "Papel", value: "papelDescricao" },
        { text: "Ação", value: "acao" },
        { text: "Verba", value: "rubrica", sortable: false },
        { text: "Classificação", value: "classificacao", sortable: false },
      ],
    };
  },
  computed: {
    pendentes() {
      return this.verbas.filter((v) => v.ativa && (v.pendencias || []).length);
    },
  },
  mounted() {
    this.carregar();
  },
  methods: {
    async carregar() {
      this.carregando = true;
      try {
        const r = await FuncionarioFolhaPagamentoVerbaDataService.getCalculo();
        this.verbas = r.data;
      } catch (e) {
        this.verbas = [];
      }
      await this.carregarSemVerba();
      this.carregando = false;
    },
    async carregarSemVerba() {
      try {
        const r =
          await FuncionarioFolhaPagamentoVerbaDataService.getPapeisSemVerba();
        this.semVerba = r.data;
      } catch (e) {
        this.semVerba = [];
      }
    },
    folhasDoPapel(p) {
      return p.folhas.map((f) => FOLHAS[f] || f).join(", ");
    },
    verbaSugerida(p) {
      return p.candidataDescricao && p.candidataDescricao !== p.candidataCodigo
        ? `${p.candidataCodigo} - ${p.candidataDescricao}`
        : p.candidataCodigo;
    },
    async abrirPadrao() {
      this.padrao = {
        aberto: true,
        carregando: true,
        propostas: [],
        selecionadas: [],
      };
      try {
        const r =
          await FuncionarioFolhaPagamentoVerbaDataService.getPropostaPadrao();
        this.padrao.propostas = r.data;
        this.padrao.selecionadas = r.data.filter(
          (p) => p.selecionada && p.acao !== "MANTER"
        );
      } catch (e) {
        this.mostrarErro(e);
      } finally {
        this.padrao.carregando = false;
      }
    },
    async aplicarPadrao() {
      this.ocupado = "Aplicando as rubricas padrão";
      try {
        const r = await FuncionarioFolhaPagamentoVerbaDataService.aplicarPadrao(
          this.padrao.selecionadas
        );
        this.verbas = r.data;
        await this.carregarSemVerba();
        this.padrao.aberto = false;
        this.$emit("aplicado");
        this.$swal.fire(
          "Rubricas configuradas",
          "As rubricas padrão foram aplicadas às verbas.",
          "success"
        );
      } catch (e) {
        this.mostrarErro(e);
      } finally {
        this.ocupado = null;
      }
    },
  },
};
</script>
<style scoped>
.verbas-cfp {
  border: 1px solid #e4e7ec !important;
  border-radius: 12px !important;
  padding: 16px 18px;
}
.verbas-cfp__topo {
  align-items: flex-start;
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: space-between;
}
.verbas-cfp__texto {
  display: flex;
  flex: 1 1 420px;
  flex-direction: column;
  max-width: 760px;
}
.verbas-cfp__kicker {
  color: #5e72e4;
  font-size: 0.68rem;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}
.verbas-cfp__texto strong {
  color: #202538;
  font-size: 1rem;
}
.verbas-cfp__texto small {
  color: #667085;
}
.verbas-cfp__acoes {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.verbas-cfp__pendentes {
  border: 1px solid #fedf89;
  border-radius: 10px;
  margin-top: 12px;
  overflow: hidden;
}
</style>
